<template>
  <!-- 注册登录块 -->
  <div class="login-popUp-box fade" id="login-box">
    <sign-in></sign-in>
    <sign-up></sign-up>
    <forget-password></forget-password>
  </div>
</template>

<script>
import SignIn from "./sub/SignIn";
import SignUp from "./sub/SignUp";
import ForgetPassword from "./sub/ForgetPassword";
export default {
  name: "MyAuth",
  components: { ForgetPassword, SignUp, SignIn }
};
</script>

<style scoped></style>
